module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/yellow-star-4c3f8a8599bc35406d4039b07b1d2b39.png";